/*!
 * custom-blog-img-webp.js (TASK-11: 2026-05-15)
 * 目的: ブログ記事本文の <img data-blog-img> を <picture> + WebP source + srcset でアップグレード
 * 対象: .blog-article-content 内の Shopify CDN 由来 <img>
 * 効果: WebP配信を強制 + responsive srcset で過剰サイズダウンロード抑止 → LCP/CWV改善
 */
(function () {
  'use strict';

  if (typeof window === 'undefined' || !('URL' in window) || !document.querySelectorAll) return;

  var SHOPIFY_CDN_RE = /(cdn\.shopify\.com|myshopify\.com\/cdn|\/cdn\/shop\/)/;
  var WIDTHS = [400, 800, 1200, 1600];
  var SIZES = '(min-width: 750px) min(720px, 100vw), 100vw';

  function buildUrl(rawSrc, width, asWebp) {
    var base = rawSrc;
    if (base.indexOf('//') === 0) base = window.location.protocol + base;
    try {
      var u = new URL(base, window.location.origin);
      u.searchParams.set('width', String(width));
      if (asWebp) u.searchParams.set('format', 'webp');
      return u.toString();
    } catch (e) {
      return rawSrc;
    }
  }

  function buildSrcset(rawSrc, asWebp) {
    return WIDTHS.map(function (w) {
      return buildUrl(rawSrc, w, asWebp) + ' ' + w + 'w';
    }).join(', ');
  }

  function upgrade(img) {
    try {
      if (!img || img.dataset.blogImgUpgraded === '1') return;
      var src = img.getAttribute('src');
      if (!src || !SHOPIFY_CDN_RE.test(src)) return;
      if (img.closest && img.closest('picture')) return;
      if (!img.parentNode) return;

      var picture = document.createElement('picture');
      var sourceWebp = document.createElement('source');
      sourceWebp.type = 'image/webp';
      sourceWebp.setAttribute('srcset', buildSrcset(src, true));
      sourceWebp.setAttribute('sizes', SIZES);
      picture.appendChild(sourceWebp);

      if (!img.getAttribute('srcset')) {
        img.setAttribute('srcset', buildSrcset(src, false));
      }
      if (!img.getAttribute('sizes')) {
        img.setAttribute('sizes', SIZES);
      }
      img.dataset.blogImgUpgraded = '1';

      img.parentNode.insertBefore(picture, img);
      picture.appendChild(img);
    } catch (e) {
      if (window.console && console.warn) console.warn('[blog-img-webp] upgrade failed', e);
    }
  }

  function run() {
    var scope = document.querySelector('.blog-article-content');
    if (!scope) return;
    var imgs = scope.querySelectorAll('img[data-blog-img]');
    for (var i = 0; i < imgs.length; i++) upgrade(imgs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
